module.exports = __webpack_public_path__ + "img/mob3.f8c07489.png";